import React, { useEffect, useState } from "react";
import { db } from "../firebase/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";

const presetsDoc = collection(db, "presets");

export default function DropDown(props) {
  const { selesctedPreset, setSelectedPreset } = props;
  const [presets, setPresets] = useState([]);
  useEffect(() => {
    getDocs(presetsDoc).then((snaps) => {
      snaps.forEach((doc) => {
        const newDoc = doc.data();
        const array = Object.keys(newDoc);

        setPresets(array.sort());
      });
    });
  }, []);

  return (
    <div className="relative inline-block">
      <select
        id="preset"
        value={selesctedPreset || ""}
        onChange={(e) => {
          setSelectedPreset(e.target.value);
        }}
        className="block min-w-[15rem] cursor-pointer appearance-none rounded-xl border border-white/10 bg-navy-700 py-3 pl-4 pr-10 text-white outline-none transition-colors hover:border-accent/50 focus:border-accent focus:ring-2 focus:ring-accent"
      >
        <option value="">Select Preset</option>
        {presets.map((p) => {
          return (
            <option key={p} value={p}>
              {p}
            </option>
          );
        })}
      </select>
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        className="pointer-events-none absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 text-accent"
      >
        <path
          fillRule="evenodd"
          d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.39a.75.75 0 0 1-1.08 0L5.21 8.27a.75.75 0 0 1 .02-1.06z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
}
